import { IOutcomeData } from './outcome-data.entity';
import { defaultEntityState } from '../entity';
import {
  mergeEntityState,
  mergeEntityStateWithNormalizedPayload,
  normalizeAndRemoveEntities,
  removeEntitiesByFilter,
} from '@core/state/entities/entity.helpers';
import { studyOutgoingDtoSchema } from '@core/services/stage/review-effects';
import { normalize } from 'normalizr';
import { createReducer, on } from '@ngrx/store';
import { stageActions, stageStudyActions } from '@core/actions/stage.actions';
import { entityKey } from '@core/state/entities/entity-name-map';

export const outcomeDataEntityReducer = createReducer(
  defaultEntityState<IOutcomeData>(),

  on(stageActions.updateSession, (state, props) => {
    const outcomeDataState = mergeEntityState(
      entityKey.outcomeData,
      state,
      props,
      (od) => {
        const session = props.entities.sessions[props.sessionId];
        const hasExtractionData = !!props.entities.outcomeData;
        return (
          hasExtractionData &&
          od.studyId === session.studyId &&
          (session.reconciliation ||
            od.investigatorId === session.investigatorId) &&
          od.reconciled === session.reconciliation
        );
      }
    );
    return outcomeDataState;
  }),
  // AF2 correlated saves commit the authoritative response here because their
  // saveSession request is non-optimistic; v1 already merged on saveSession.
  on(stageActions.sessionSaved, (state, props) =>
    props.correlationId !== undefined
      ? mergeEntityState(entityKey.outcomeData, state, props)
      : state
  ),
  on(stageStudyActions.receivedStageStudy, (state, props) =>
    mergeEntityState(entityKey.outcomeData, state, props)
  ),
  on(stageActions.saveSession, (state, props) =>
    props.correlationId !== undefined
      ? state
      : mergeEntityStateWithNormalizedPayload(
          entityKey.outcomeData,
          state,
          normalize(props, studyOutgoingDtoSchema),
          (od) => {
            const pl = props;
            const hasExtractionData = !!props.outcomeData;
            return (
              hasExtractionData &&
              od.studyId === pl.studyId &&
              (pl.session.reconciliation ||
                od.investigatorId === pl.session.investigatorId) &&
              od.reconciled === pl.reconciliation
            );
          }
        )
  ),
  on(stageActions.deleteSession, (state, props) =>
    props.correlationId !== undefined
      ? state
      : normalizeAndRemoveEntities(
          entityKey.outcomeData,
          state,
          props,
          studyOutgoingDtoSchema
        )
  ),
  on(stageActions.commitSessionDeletion, (state, props) =>
    removeEntitiesByFilter(
      state,
      (outcomeData) =>
        outcomeData.projectId === props.projectId &&
        outcomeData.studyId === props.studyId &&
        outcomeData.stageId === props.stageId &&
        (props.reconciliation ||
          outcomeData.investigatorId === props.session.investigatorId) &&
        outcomeData.reconciled === props.reconciliation
    )
  )
);
